// Options communes au client (entrypoints/inertia.tsx) et au SSR (ssr/ssr.tsx).
import type { Page } from '@inertiajs/core'
import { resolveLayout } from '@/layouts/resolve'

export const inertiaOptions = {
  // Le <title> complet est calculé par le serveur (seoHead) : pas de gabarit.
  title: (title: string) => title,
  // Balises du <head> propres à la page (titre, description, canonical, Open
  // Graph, JSON-LD…), rendues par Rails et tenues à jour à chaque
  // navigation.
  serverHead: (page: Page) => ((page.props as { seoHead?: string[] }).seoHead ?? []),
  layout: (name: string, page: Page) => resolveLayout(name, page),
  defaults: {
    // Préchargement après 250 ms de survol (une intention de clic, pas un
    // simple passage de souris vers un autre lien), réponse gardée 30 s.
    prefetch: { cacheFor: '30s', hoverDelay: 250 },
  },
}
